// FETCH ALL PROPERTIES FROM STITCHING_DC DETAILS
export const FETCH_STITCHING_DC_DETAILS_REQUEST_DK = 'FETCH_STITCHING_DC_DETAILS_REQUEST_DK';
export const FETCH_STITCHING_DC_DETAILS_SUCCESS_DK = 'FETCH_STITCHING_DC_DETAILS_SUCCESS_DK';
export const FETCH_STITCHING_DC_DETAILS_FAILURE_DK = 'FETCH_STITCHING_DC_DETAILS_FAILURE_DK';

// FETCH ALL PROPERTIES FROM STITCHING_DC DETAILS
export const FETCH_STITCHING_DC_DETAILS_PROGRAM_REQUEST_DK = 'FETCH_STITCHING_DC_DETAILS_PROGRAM_REQUEST_DK';
export const FETCH_STITCHING_DC_DETAILS_PROGRAM_SUCCESS_DK = 'FETCH_STITCHING_DC_DETAILS_PROGRAM_SUCCESS_DK';
export const FETCH_STITCHING_DC_DETAILS_PROGRAM_FAILURE_DK = 'FETCH_STITCHING_DC_DETAILS_PROGRAM_FAILURE_DK';

export const FETCH_STITCHING_DC_DETAIL_EDIT_QUANTITY_REQUEST_DK = 'FETCH_STITCHING_DC_DETAIL_EDIT_QUANTITY_REQUEST_DK';
export const FETCH_STITCHING_DC_DETAIL_EDIT_QUANTITY_SUCCESS_DK = 'FETCH_STITCHING_DC_DETAIL_EDIT_QUANTITY_SUCCESS_DK';
export const FETCH_STITCHING_DC_DETAIL_EDIT_QUANTITY_FAILURE_DK = 'FETCH_STITCHING_DC_DETAIL_EDIT_QUANTITY_FAILURE_DK';

// FETCH ALL PROPERTIES FROM STITCHING_DC DETAILS BY ID
export const FETCH_STITCHING_DC_DETAILS_BY_ID_REQUEST_DK = 'FETCH_STITCHING_DC_DETAILS_BY_ID_REQUEST_DK';
export const FETCH_STITCHING_DC_DETAILS_BY_ID_SUCCESS_DK = 'FETCH_STITCHING_DC_DETAILS_BY_ID_SUCCESS_DK';
export const FETCH_STITCHING_DC_DETAILS_BY_ID_FAILURE_DK = 'FETCH_STITCHING_DC_DETAILS_BY_ID_FAILURE_DK';

// CREATE PROPERTIES FOR STITCHING_DC DETAILS
export const CREATE_STITCHING_DC_DETAILS_REQUEST_DK = 'CREATE_STITCHING_DC_DETAILS_REQUEST_DK';
export const CREATE_STITCHING_DC_DETAILS_SUCCESS_DK = 'CREATE_STITCHING_DC_DETAILS_SUCCESS_DK';
export const CREATE_STITCHING_DC_DETAILS_FAILURE_DK = 'CREATE_STITCHING_DC_DETAILS_FAILURE_DK';

export const CREATE_STITCHING_DC_DETAIL_EDIT_QTY_MASTER_REQUEST_DK = 'CREATE_STITCHING_DC_DETAIL_EDIT_QTY_MASTER_REQUEST_DK';
export const CREATE_STITCHING_DC_DETAIL_EDIT_QTY_MASTER_SUCCESS_DK = 'CREATE_STITCHING_DC_DETAIL_EDIT_QTY_MASTER_SUCCESS_DK';
export const CREATE_STITCHING_DC_DETAIL_EDIT_QTY_MASTER_FAILURE_DK = 'CREATE_STITCHING_DC_DETAIL_EDIT_QTY_MASTER_FAILURE_DK';

//CREATE USER FORM
export const CREATE_USER_FORM_STITCHING_DC_DETAILS_DK = 'CREATE_USER_FORM_STITCHING_DC_DETAILS_DK';

export const CREATE_USER_FORM_STITCHING_DC_EDIT_QTY_DK = 'CREATE_USER_FORM_STITCHING_DC_EDIT_QTY_DK';

export const RESET_STITCHING_DC_EDIT_QTY_DK = 'RESET_STITCHING_DC_EDIT_QTY_DK';

// UPDATE PROPERTIES FOR STITCHING_DC DETAILS
export const UPDATE_STITCHING_DC_DETAILS_REQUEST_DK = 'UPDATE_STITCHING_DC_DETAILS_REQUEST_DK';
export const UPDATE_STITCHING_DC_DETAILS_SUCCESS_DK = 'UPDATE_STITCHING_DC_DETAILS_SUCCESS_DK';
export const UPDATE_STITCHING_DC_DETAILS_FAILURE_DK = 'UPDATE_STITCHING_DC_DETAILS_FAILURE_DK';

// FETCH SINGLE STITCHING_DC_DETAILS
export const FETCH_SINGLE_STITCHING_DC_DETAILS_REQUEST_DK = 'FETCH_SINGLE_STITCHING_DC_DETAILS_REQUEST_DK';
export const FETCH_SINGLE_STITCHING_DC_DETAILS_SUCCESS_DK = 'FETCH_SINGLE_STITCHING_DC_DETAILS_SUCCESS_DK';
export const FETCH_SINGLE_STITCHING_DC_DETAILS_FAILURE_DK = 'FETCH_SINGLE_STITCHING_DC_DETAILS_FAILURE_DK';

// DELETE PROPERTIES FOR STITCHING_DC DETAILS
export const DELETE_STITCHING_DC_DETAILS_REQUEST_DK = 'DELETE_STITCHING_DC_DETAILS_REQUEST_DK';
export const DELETE_STITCHING_DC_DETAILS_SUCCESS_DK = 'DELETE_STITCHING_DC_DETAILS_SUCCESS_DK';
export const DELETE_STITCHING_DC_DETAILS_FAILURE_DK = 'DELETE_STITCHING_DC_DETAILS_FAILURE_DK';

// USERFORM RESET

export const STITCHING_DC_DETAILS_USERFORM_RESET_DK = 'STITCHING_DC_DETAILS_USERFORM_RESET_DK';

//DCNO
export const FETCH_STITCHING_DC_DETAILS_DC_NO_REQUEST_DK_DK = 'FETCH_STITCHING_DC_DETAILS_DC_NO_REQUEST_DK_DK';
export const FETCH_STITCHING_DC_DETAILS_DC_NO_SUCCESS_DK_DK = 'FETCH_STITCHING_DC_DETAILS_DC_NO_SUCCESS_DK_DK';
export const FETCH_STITCHING_DC_DETAILS_DC_NO_FAILURE_DK_DK = 'FETCH_STITCHING_DC_DETAILS_DC_NO_FAILURE_DK_DK';

//GRN NO
export const FETCH_GRN_NO_BY_STITCHING_DC_NO_REQUEST_DK_DK = 'FETCH_GRN_NO_BY_STITCHING_DC_NO_REQUEST_DK_DK';
export const FETCH_GRN_NO_BY_STITCHING_DC_NO_SUCCESS_DK_DK = 'FETCH_GRN_NO_BY_STITCHING_DC_NO_SUCCESS_DK_DK';
export const FETCH_GRN_NO_BY_STITCHING_DC_NO_FAILURE_DK_DK = 'FETCH_GRN_NO_BY_STITCHING_DC_NO_FAILURE_DK_DK';
